/**
 * Cooling System per-instance editor — placeholders for the 8 cooling fields (#996 Phase 2).
 * Mirrors smallUpsRequirementsUi (which carries UPS-specific dropdown options); cooling has
 * no per-instance dropdown option lists, so this file only exposes placeholder copy.
 * Placeholder text reuses the labels/placeholders already shown in CoolingInformation.tsx.
 */

export const COOLING_SYSTEM_PLACEHOLDERS = {
  description: 'Enter description',
  existingSystemOnsite: '',
  totalAvailableCapacityKw: 'Enter cooling capacity',
  tempRise: 'Enter temperature rise in fahrenheit',
  describeApproach: 'Describe how the site is cooled today / planned',
  rearDoorHexDesired: '',
  describeRearDoorLoop: 'Describe connection points, routing constraints, etc.',
} as const;
